import React, { createContext } from 'react';
export const TimezoneContext = createContext(Intl.DateTimeFormat().resolvedOptions().timeZone);
export const TimezoneProvider = ({ children, timezone, }) => {
    if (timezone && !isValidTimeZone(timezone))
        console.warn(`@servicetitan/design-system: Invalid timezone ${timezone}`);
    return (React.createElement(TimezoneContext.Provider, { value: timezone }, children));
};
const isValidTimeZone = (tz) => {
    if (!Intl || !Intl.DateTimeFormat().resolvedOptions().timeZone) {
        throw new Error('Time zones are not available in this environment');
    }
    try {
        Intl.DateTimeFormat(undefined, { timeZone: tz });
        return true;
    }
    catch (ex) {
        return false;
    }
};
//# sourceMappingURL=TimezoneProvider.js.map